import {
  Card,
  CardContent,
  Stack,
  Avatar,
  CardActionArea,
  Typography
} from '@mui/material'
import '../../../Style/Pulse.css'
import polls from '../../../Icons/polls.png'
import puzzle from '../../../Icons/puzzle.jpg'
import warning from '../../../Icons/warning.jpg'
import { useState } from 'react'

const ABTestingExample = ({}) => {
  const [clicked, setClicked] = useState(null)
  const options = [
    { text: 'Option 1', image: polls },
    { text: 'Option 2', image: puzzle },
    { text: 'Option 3', image: warning }
  ]
  return (
    <Stack
      spacing={{ xs: 1, md: 2 }}
      direction='row'
      justifyContent='center'
      useFlexGap
      sx={{ flexWrap: 'wrap', pb: { xs: 1, md: 2 } }}
    >
      {options.map((option, optionIndex) => (
        <Card
          raised
          key={optionIndex + '_option'}
          className='abTestingCard'
          sx={{
            backgroundColor: clicked === option.text ? 'primary.main' : 'unset',
            color: clicked === option.text ? 'primary.contrastText' : 'unset'
          }}
        >
          <CardActionArea
            sx={{ height: '100%' }}
            onClick={() => {
              setClicked(option.text)
            }}
          >
            <CardContent>
              <Avatar
                sx={{
                  width: 'auto',
                  height: 'auto',
                  maxHeight: { md: 200, xs: 150 },
                  maxWidth: { md: 200, xs: 150 },
                  margin: 'auto'
                }}
                loading='lazy'
                variant='rounded'
                className='previewFrame'
                src={option.image}
              />
              <Typography variant='span'>{option.text}</Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Stack>
  )
}

export default ABTestingExample
